import * as React from 'react';
import { cx } from '@/lib/ui';

type EmptyStateProps = {
  title: React.ReactNode;
  description?: React.ReactNode;
  icon?: React.ReactNode;
  action?: React.ReactNode;
  compact?: boolean;
  className?: string;
};

export default function EmptyState({
  title,
  description,
  icon,
  action,
  compact = false,
  className,
}: EmptyStateProps) {
  return (
    <div
      className={cx(
        'flex flex-col items-center justify-center text-center',
        compact
          ? 'gap-2 py-6'
          : 'min-h-44 gap-3 rounded-aula-lg border border-dashed border-aula-border bg-white/80 p-6',
        className
      )}
    >
      {icon ? (
        <div className="flex h-11 w-11 items-center justify-center rounded-full bg-slate-100 text-slate-500">
          {icon}
        </div>
      ) : null}
      <div>
        <div className="font-bold text-slate-900">{title}</div>
        {description ? (
          <div className="mx-auto mt-1 max-w-xl text-sm leading-6 text-slate-600">
            {description}
          </div>
        ) : null}
      </div>
      {action ? <div className="mt-1">{action}</div> : null}
    </div>
  );
}
